(function($){
    var minImageHeight = 380;

    $(window).on('load resize', function(event){
        setImageHeight();
    });

    function setImageHeight() {
        $('.content-menu').each(function () {
            var $this = $(this),
                $image = $this.find('.content-menu__image'),
                $content = $this.find('.content-menu__content'),
                contentHeight = $content.innerHeight();

            if (contentHeight > minImageHeight) {
                $image.css('height', contentHeight + 'px');
            }
        });
    }

}(jQuery));
